import { render, staticRenderFns } from "./ForecastingManagement.vue?vue&type=template&id=6d88271a&scoped=true&"
import script from "./ForecastingManagement.vue?vue&type=script&lang=js&"
export * from "./ForecastingManagement.vue?vue&type=script&lang=js&"
import style0 from "./ForecastingManagement.vue?vue&type=style&index=0&id=6d88271a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88271a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VProgressCircular})
